import { FC } from 'react';

import { useUserConnectionsQuery } from '@queries/UserConnectionsQueries';

import { PrimaryCtaCard } from '@components/layout/PrimaryCtaCard/PrimaryCtaCard';

import UserQuestionSvg from '../assets/user-question.svg';

export const SuggestedConnectionsBannerLink: FC<{ className?: string }> = ({
  className = 'mb-3',
}) => {
  const { suggestedConnections } = useUserConnectionsQuery();

  if (!suggestedConnections.length) return <></>;

  return (
    <div className={className}>
      <PrimaryCtaCard
        cta={{
          img: UserQuestionSvg,
          title: 'Suggested Connections',
          description: 'Explore friends of friends to see who you might know.',
          url: '/manage/connections/suggested',
          badgeCount: suggestedConnections.length,
        }}
        track={{ event: 'Click Suggested Connections Banner' }}
      />
    </div>
  );
};
